"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _A = require("../../../UI/A");
var _Button = require("../../../UI/Button");
var _hooks = require("../../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
var Alert = function Alert(props) {
  var type = props.type,
    handleClose = props.handleClose,
    isNmm = props.isNmm,
    _props$supportUrl = props.supportUrl,
    supportUrl = _props$supportUrl === void 0 ? '' : _props$supportUrl;
  var _useSessionData = (0, _hooks.useSessionData)(),
    firstName = _useSessionData.firstName;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    getLabel = _useContext.getLabel,
    setIsChangedBackToExam = _useContext.setIsChangedBackToExam,
    setUpdateTaskTypeAfterExamStart = _useContext.setUpdateTaskTypeAfterExamStart,
    updateTaskTypeAfterExamStart = _useContext.updateTaskTypeAfterExamStart,
    reSubmitTaskAfterTaskTypeChanged = _useContext.reSubmitTaskAfterTaskTypeChanged,
    setReSubmitTaskAfterTaskTypeChanged = _useContext.setReSubmitTaskAfterTaskTypeChanged;
  var handleGoBack = function handleGoBack() {
    setIsChangedBackToExam(true);
    setUpdateTaskTypeAfterExamStart(null);
  };
  var handleCloseOnConfirm = function handleCloseOnConfirm() {
    if (handleClose) {
      handleClose();
    }
  };
  var handleConfirm = function handleConfirm() {
    switch (type) {
      case 'updateTaskTypeAfterExamStart':
        updateTaskTypeAfterExamStart.handleConfirm();
        break;
      case 'reSubmitTaskAfterTaskTypeChanged':
        reSubmitTaskAfterTaskTypeChanged.handleConfirm();
        setReSubmitTaskAfterTaskTypeChanged(false);
        break;
      default:
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [type === 'updateTaskTypeAfterExamStart' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: getLabel('alert_change_exam_type_is_irreversible'),
        subTitle: getLabel('alert_can_not_re_exam')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
        children: [getLabel('alert_extra_submit'), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('alert_check_not_saved'), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: getLabel('alert_continue_with_change')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "link",
            onClick: handleGoBack,
            children: getLabel('back')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            onClick: handleConfirm,
            children: getLabel('confirm')
          })
        })]
      })]
    }), type === 'reSubmitTaskAfterTaskTypeChanged' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        subTitle: getLabel('alert_reSubmit_task')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            onClick: handleConfirm,
            children: getLabel('confirm')
          })
        })
      })]
    }), type === 'noAudience' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: "".concat(getLabel('alert_hi'), " ").concat(firstName)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
        children: isNmm ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [getLabel('alert_no_audience'), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('alert_no_audience_grades')]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [getLabel('alert_no_audience_support'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
            to: supportUrl,
            target: "_blank",
            children: getLabel('alert_no_audience_help')
          }), getLabel('alert_no_audience_contact')]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            onClick: handleCloseOnConfirm,
            children: getLabel('confirm')
          })
        })
      })]
    })]
  });
};
exports.Alert = Alert;